import Global from '../store/global-selectors';
import { useSelector } from 'react-redux';

export const useActiveUsers = () => {
  const users = useSelector(Global.selectSellerUsers);
  const activeUsers = users.filter((u) => u.isActive);
  return activeUsers;
};
